import React from 'react';
import Landing2Navbar from '../components/Landing2navbar';
import Landing2Header from '../components/servicepage/landingheader2';
import useScrollTransition from '../useScrollTransition';
import ScrollingText2 from '../components/servicepage/lettersslider2';
import WritingServices from './landing2service1';
import FooterLanding2 from './landing2footer';
import WhatsAppConnect from '../components/whatsapplink';
import Freebies from '../components/landing2contact';
import Landing2about from './landing2about';
import WhyChooseUs from './landing2service2';
import OurWorkspace from './landing2service3';
import FaqAboutService from './landing2service4';
import ReviewSection from './landing2review';



const Landingpg2 = () => {
  useScrollTransition();
  return (
    <>
    <Landing2Navbar />
      <Landing2Header />
      <WhatsAppConnect />
      <ScrollingText2 />
      <Landing2about />
      <WritingServices />
      <WhyChooseUs />
      <OurWorkspace />
      <FaqAboutService />
      <ReviewSection />
      <Freebies />
      <FooterLanding2 />
    </>
  );
};

export default Landingpg2;
